// fetch all users
export const GET_USERS_START = 'GET_USERS_START';
export const GET_USERS_FULFILLED = 'GET_USERS_FULFILLED';
export const GET_USERS_REJECTED = 'GET_USERS_REJECTED';
// fetch groups
export const GET_GROUPS_START = 'GET_GROUPS_START';
export const GET_GROUPS_FULFILLED = 'GET_GROUPS_FULFILLED';
export const GET_GROUPS_REJECTED = 'GET_GROUPS_REJECTED';
// fetch all exercises
export const FETCH_EXERCISES_START = 'FETCH_EXERCISES_START';
export const FETCH_EXERCISES_FULFILLED = 'FETCH_EXERCISES_FULFILLED';
export const FETCH_EXERCISES_REJECTED = 'FETCH_EXERCISES_REJECTED';
// fetch all entries
export const FETCH_JOURNAL_ENTRIES_START = 'FETCH_JOURNAL_ENTRIES_START';
export const FETCH_JOURNAL_ENTRIES_FULFILLED = 'FETCH_JOURNAL_ENTRIES_FULFILLED';
export const FETCH_JOURNAL_ENTRIES_REJECTED = 'FETCH_JOURNAL_ENTRIES_REJECTED';
// fetch entries for single athlete
export const SET_SELECTED_ATHLETE = 'SET_SELECTED_ATHLETE';
export const FETCH_ENTRIES_FOR_ATHLETE_START = 'FETCH_ENTRIES_FOR_ATHLETE_START';
export const FETCH_ENTRIES_FOR_ATHLETE_FULFILLED = 'FETCH_ENTRIES_FOR_ATHLETE_FULFILLED';
export const FETCH_ENTRIES_FOR_ATHLETE_REJECTED = 'FETCH_ENTRIES_FOR_ATHLETE_REJECTED';
// fetch entries for single group
export const SET_CURRENT_GROUP = 'SET_CURRENT_GROUP';
export const FETCH_ENTRIES_FOR_GROUP_START = 'FETCH_ENTRIES_FOR_GROUP_START';
export const FETCH_ENTRIES_FOR_GROUP_FULFILLED = 'FETCH_ENTRIES_FOR_GROUP_FULFILLED';
export const FETCH_ENTRIES_FOR_GROUP_REJECTED = 'FETCH_ENTRIES_FOR_GROUP_REJECTED';
// fetch me journal entries
export const FETCH_ME_JOURNAL_ENTRIES_START = 'FETCH_ME_JOURNAL_ENTRIES_START ';
export const FETCH_ME_JOURNAL_ENTRIES_FULFILLED = 'FETCH_ME_JOURNAL_ENTRIES_FULFILLED ';
export const FETCH_ME_JOURNAL_ENTRIES_REJECTED = 'FETCH_ME_JOURNAL_ENTRIES_REJECTED ';
// fetch next page for infinite load
export const FETCH_NEXT_JOURNAL_PAGE_START = 'FETCH_NEXT_JOURNAL_PAGE_START';
export const FETCH_NEXT_JOURNAL_PAGE_FULFILLED = 'FETCH_NEXT_JOURNAL_PAGE_FULFILLED';
export const FETCH_NEXT_JOURNAL_PAGE_REJECTED = 'FETCH_NEXT_JOURNAL_PAGE_REJECTED';
// create me journal entries
export const CREATE_JOURNAL_ENTRIES_START = 'CREATE_JOURNAL_ENTRIES_START';
export const CREATE_JOURNAL_ENTRIES_FULFILLED = 'CREATE_JOURNAL_ENTRIES_FULFILLED';
export const CREATE_JOURNAL_ENTRIES_REJECTED = 'CREATE_JOURNAL_ENTRIES_REJECTED';
// write note in an athlete's journal from coach
export const CREATE_ENTRY_TO_ATHLETE_START = 'CREATE_ENTRY_TO_ATHLETE_START';
export const CREATE_ENTRY_TO_ATHLETE_FULFILLED = 'CREATE_ENTRY_TO_ATHLETE_FULFILLED';
export const CREATE_ENTRY_TO_ATHLETE_REJECTED = 'CREATE_ENTRY_TO_ATHLETE_REJECTED';
// update me journal entry
export const SET_EDIT_JOURNAL_ENTRY = 'SET_EDIT_JOURNAL_ENTRY';
export const UPDATE_JOURNAL_ENTRY_START = 'UPDATE_JOURNAL_ENTRY_START';
export const UPDATE_JOURNAL_ENTRY_FULFILLED = 'UPDATE_JOURNAL_ENTRY_FULFILLED';
export const UPDATE_JOURNAL_ENTRY_REJECTED = 'UPDATE_JOURNAL_ENTRY_REJECTED';
// delete me journal entry
export const DELETE_ME_JOURNAL_ENTRIES_START = 'DELETE_ME_JOURNAL_ENTRIES_START';
export const DELETE_ME_JOURNAL_ENTRIES_FULFILLED = 'DELETE_ME_JOURNAL_ENTRIES_FULFILLED';
export const DELETE_ME_JOURNAL_ENTRIES_REJECTED = 'DELETE_ME_JOURNAL_ENTRIES_REJECTED';
// set filter options
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS';
export const SET_DATE_RANGE = 'SET_DATE_RANGE';
export const SET_IS_END_OF_LIST = 'SET_IS_END_OF_LIST';
export const SET_EXERCISE_TAB = 'SET_EXERCISE_TAB';
export const SET_TEMP_EXERCISE = 'SET_TEMP_EXERCISE';
export const SET_EXERCISE_FILTER = 'SET_EXERCISE_FILTER';
// media
export const UPLOAD_MEDIA_START = 'UPLOAD_MEDIA_START';
export const UPLOAD_MEDIA_FULFILLED = 'UPLOAD_MEDIA_FULFILLED';
export const UPLOAD_MEDIA_REJECTED = 'UPLOAD_MEDIA_REJECTED';
export const SET_UPLOAD_MEDIA_FALSE = 'SET_UPLOAD_MEDIA_FALSE';
export const UPLOAD_COMMENT_MEDIA_START = 'UPLOAD_COMMENT_MEDIA_START';
export const UPLOAD_COMMENT_MEDIA_FULFILLED = 'UPLOAD_COMMENT_MEDIA_FULFILLED';
export const UPLOAD_COMMENT_MEDIA_REJECTED = 'UPLOAD_COMMENT_MEDIA_REJECTED';
export const UPLOAD_COMMENT_MEDIA_URL_START = 'UPLOAD_COMMENT_MEDIA_URL_START';
export const UPLOAD_COMMENT_MEDIA_URL_FULFILLED = 'UPLOAD_COMMENT_MEDIA_URL_FULFILLED';
export const UPLOAD_COMMENT_MEDIA_URL_REJECTED = 'UPLOAD_COMMENT_MEDIA_URL_REJECTED';
export const SET_UPLOAD_COMMENT_MEDIA_FALSE = 'SET_UPLOAD_COMMENT_MEDIA_FALSE';
export const SET_COMMENT_MEDIA_TARGET = 'SET_COMMENT_MEDIA_TARGET';
export const SET_REMOVE_MEDIA_ARRAY = 'SET_REMOVE_MEDIA_ARRAY';
export const CLEAR_REMOVE_MEDIA_ARRAY = 'CLEAR_REMOVE_MEDIA_ARRAY';
export const SET_MESSAGE_MEDIA_URL = 'SET_MESSAGE_MEDIA_URL';
// manage modals
export const SET_ACTIVE_REDUX_MODAL = 'SET_ACTIVE_REDUX_MODAL';
export const SET_SUB_ACTIVE_REDUX_MODAL = 'SET_SUB_ACTIVE_REDUX_MODAL';
// set tab selector and journal content
export const SET_JOURNAL_TAB = 'SET_JOURNAL_TAB';
// create comment
export const CREATE_JOURNAL_ENTRY_COMMENT_START = 'CREATE_JOURNAL_ENTRY_COMMENT_START';
export const CREATE_JOURNAL_ENTRY_COMMENT_FULFILLED = 'CREATE_JOURNAL_ENTRY_COMMENT_FULFILLED';
export const CREATE_JOURNAL_ENTRY_COMMENT_REJECTED = 'CREATE_JOURNAL_ENTRY_COMMENT_REJECTED';
// update comment
export const SET_EDIT_COMMENT = 'SET_EDIT_COMMENT';
export const EDIT_JOURNAL_ENTRY_COMMENT_START = 'EDIT_JOURNAL_ENTRY_COMMENT_START';
export const EDIT_JOURNAL_ENTRY_COMMENT_FULFILLED = 'EDIT_JOURNAL_ENTRY_COMMENT_FULFILLED';
export const EDIT_JOURNAL_ENTRY_COMMENT_REJECTED = 'EDIT_JOURNAL_ENTRY_COMMENT_REJECTED';
// delete comment
export const DELETE_JOURNAL_ENTRY_COMMENT_START = 'DELETE_JOURNAL_ENTRY_COMMENT_START';
export const DELETE_JOURNAL_ENTRY_COMMENT_FULFILLED = 'DELETE_JOURNAL_ENTRY_COMMENT_FULFILLED';
export const DELETE_JOURNAL_ENTRY_COMMENT_REJECTED = 'DELETE_JOURNAL_ENTRY_COMMENT_REJECTED';
// report comment to support
export const SET_REPORT_POST_ID = 'SET_REPORT_POST_ID';
export const SUBMIT_SUPPORT_START = 'SUBMIT_SUPPORT_START';
export const SUBMIT_SUPPORT_FULFILLED = 'SUBMIT_SUPPORT_FULFILLED';
export const SUBMIT_SUPPORT_REJECTED = 'SUBMIT_SUPPORT_REJECTED';
// error reseting
export const RESET_ENTRY_ERROR = 'RESET_ENTRY_ERROR';
export const RESET_COMMENT_ERROR = 'RESET_COMMENT_ERROR';
export const RESET_SUPPORT_ERROR = 'RESET_SUPPORT_ERROR';
